import React from 'react';
import { injectIntl, WrappedComponentProps } from 'react-intl';

import { HttpError } from '@/services/network/http';
import { translations } from '@/locale';

import Typography from '@/components/Typography';

interface Props {
  error: HttpError<any> | undefined | null;
}

const Error: React.FC<Props & WrappedComponentProps> = ({ intl, error }) => {
  if (!error) return null;

  const hasError = error.isAxiosError && error.response && error.response.data && error.response.data.error;

  let errorMessage: string;

  if (hasError) {
    const errorCode = error.response.data.error;
    errorMessage = translations.errors.api[errorCode]
      ? intl.formatMessage({ id: translations.errors.api[errorCode] })
      : null;
  } else {
    errorMessage = error.message;
  }

  return (
    <Typography className="inline-block px-2 py-2 text-left rounded-2xl" is="div" color="red">
      {errorMessage}
    </Typography>
  );
};

export const AuthError = injectIntl(Error);
